import React, { useEffect, useState } from "react";
import { Col, Card, Badge } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import EmptyState from "./EmptyState";

const InfostealersMessages = () => {
  const [messages, setMessages] = useState([]);
  const message_type = "null";

  const fetchMessages = () => {
    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/messages/type/${message_type}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setMessages(response.data);
      })
      .catch((error) => console.error("Failed to fetch messages: ", error));
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const hasData = messages?.length > 0;

  return (
    <Col md={4} className="mb-4">
      <Card style={{ minHeight: "360px" }}>
        <Card.Body className={hasData ? "scrollable-card-body" : ""}>
          <h6 className="fw-bold mb-2 text-muted">{`Latest InfoStealers`}</h6>
          {!hasData ? (
            <EmptyState title="No infostealers found" />
          ) : (
            messages.map((message, index) => (
              <Card key={index} className="mb-2">
                <Card.Body className="py-1">
                  <div className={"mb-2"}>
                    <div className="d-flex justify-content-between mb-2">
                      <span className="inline-block small">
                        <Badge
                          bg="info"
                          style={{ fontSize: "10px" }}
                        >{`Infostealers`}</Badge>{" "}
                      </span>
                    </div>
                    {message?.alert && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        {message?.alert}
                      </small>
                    )}
                    {message?.author && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">
                          Threat Actor:
                        </span>{" "}
                        {message?.author}
                      </small>
                    )}
                    <small className="d-block" style={{ fontSize: "12px" }}>
                      <span className="text-muted fw-semibold">File Name:</span>{" "}
                      {message?.file_name}
                    </small>
                    <small className="d-block" style={{ fontSize: "12px" }}>
                      <span className="text-muted fw-semibold">File Size:</span>{" "}
                      {message?.file_size
                        ? formatBytes(message?.file_size)
                        : "---"}
                    </small>
                    {message?.timestamp && (
                      <small className="d-block" style={{ fontSize: "12px" }}>
                        <span className="text-muted fw-semibold">
                          Intercepted on:
                        </span>{" "}
                        {moment(message?.timestamp).format("MMM Do YYYY, h:mm A")}{" "}
                        UTC
                      </small>
                    )}
                  </div>
                </Card.Body>
              </Card>
            ))
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default InfostealersMessages;

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
